<template>
  <div class="product">
    <div class="product__item" v-for="(data, productIndex) in products" :key="productIndex">
      <div class="product__item__img">
        <el-image class="img" fit="cover" :src="data.image"></el-image>
      </div>
      <div class="product__item__info">
        <div class="product__item__info__wrapper">
          <a :href="href(data)" target="_blank">
            <h6 class="product__item__name line-clamp-2">{{data.name}}</h6>
          </a>
          <p class="product__item__sub">
            <span>
              <i class="ficon ficon-chufadi" />
              {{ data.departure }}出发
            </span>
            <span>
              <i class="ficon ficon-zuijintuanqi" />
              最近{{ data.product_date_num }}个团期：{{ stockStr(data.product_date) }}
            </span>

          <div class="tag-group">
            <v-tag v-for="(tag, index) in data.tags" :key="index" class="tag" type="blue">{{ tag }}</v-tag>
          </div>
          </p>
        </div>
      </div>
      <div class="product__item__price">
        <p class="product__prices">
          ¥<span class="num">{{ data.min_sale_price }}</span>起
        </p>
        <a :href="href(data)" target="_blank">
          <div class="product__btn">查看详情</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { ProductTypes } from "@/constants/productType.js";

export default {
  name: "ProductList",
  components: {},
  props: {
    products: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    stockStr(product_date) {
      return product_date.map((date) => `${date.month}/${date.day}`).join("、");
    },
    href(data) {
      const product_no = data.product_no;

      // todo   跳转产品页面
      return data.product_type == ProductTypes.CRUISE
        ? `/product/cruise/${product_no}`
        : `/product/vacation/${product_no}`;
    },
  },
};
</script>

<style lang="scss" scoped>

@import "~@/assets/scss/base/_color";
.product {
  &__item {
    display: flex;
    justify-content: space-between;
    border-radius:  20px 20px 20px 20px;
    overflow: hidden;
    border: 10px solid transparent;
    &:hover {
      border-color: #dee2e6;
    }
    &:not(:last-child) {
      margin-bottom: 20px;
    }
    &__info {
      flex: 1;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        width: 680px;
        height: 100%;
        top: 0;
        right: 0;
        background: url("~assets/img/customer/customer_product_info_bg.png")
          center;
        background-size: cover;
      }
      padding: 30px 70px;
      &__wrapper {
        height: 100%;
        border-top: 1px dashed #adb5bd;
        border-bottom: 1px dashed #adb5bd;
        position: relative;
        display: flex;
        flex-direction: column;
        // align-items: center;
        justify-content: space-around;
      }
    }
    &__name {
      color: #212529;
      font-size: 18px;
      font-weight: 600;
    }
    &__img {
      height: 252px;
      position: relative;
      z-index: 1;
      &::after {
        content: "热卖";
        line-height: 35px;
        position: absolute;
        text-align: center;
        color: #fff;
        font-size: 16px;
        font-weight: 600;
        width: 60px;
        height: 40px;
        left: 0;
        top: 0;
        background: url("~assets/img/customer/customer_product_img_tag.png")
          no-repeat center;
        background-size: cover;
      }
      .img {
        width: 336px;
        border-radius: 20px;
        // overflow: hidden;
        height: 252px;
        margin-left: 8px;
        // box-shadow: 0px 2px 24px 0px rgba(0, 0, 0, 0.27);
      }
    }
    &__price {
      width: 200px;
      position: relative;
      background: linear-gradient(140deg, #f2993b 0%, #f25b3b 100%);
      text-align: center;
      border-radius: 0 20px 20px 0;
      // overflow: hidden;
      &::before {
        content: "";
        position: absolute;
        width: 122px;
        height: 63px;
        top: 13px;
        right: 13px;
        background: url("~assets/img/customer/customer_product_price_bg.png")
          no-repeat center;
        background-size: cover;
      }
    }
  }
  &__prices {
    font-size: 27px;
    font-weight: 500;
    padding-top: 70px;
    color: #fff;
    .num {
      font-weight: 41px;
    }
  }
  &__btn {
    margin-top: 32x;
    width: 102px;
    height: 46px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 14px;
    border-radius: 46px;
    border: 1px solid #fff;
    margin-top: 32px;
  }
}

</style>
